var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.appweb.moduleId == 'bTSXa6odYbFhgLHWr')?[_c('HomeTemplate')]:_vm._e(),_vm._v(" "),(_vm.appweb.moduleId == '6w3XxZ5e9CJKnTtkX')?[_c('HomeTemplate2')]:_vm._e(),_vm._v(" "),(_vm.appweb.moduleId == 'bTSXa6odYbFhgLFWt')?[_c('HomeTemplate3')]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a60afa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/choicetemplate.vue
// module id = null
// module chunks = 